import * as React from 'react'
import Form from '../../../src/containers/LandingForm'
import GoogleReviews, { ColoredStar } from '../components/Reviews'
import Faqs from '../components/Faqs'
import Layout from '../components/Layout'
import { graphql, navigate } from 'gatsby'
import styled from 'styled-components'
import splashImg from '../images/splash.jpg'
import { Grid } from '@material-ui/core'
import { secondary } from '../../../src/constants/theme'
import MoreInfoForm from '../../../src/containers/MoreInfoForm'
import { defaultFormConfig } from '../../site.config'
import Img from 'gatsby-image'
const StyledImg = styled(Img)`
    height: 80vh !important;
    picture {
        @media (max-width: 767px) {
            img {
                object-position: ${(props) =>
                    props.alt ? '-75vw center !important' : 'center center'};
            }
        }
    }
`
const Main = styled.main`
    margin: 0 auto;
    max-width: 1160px;
    padding: 0 12px;
    height: 80vh;
    display: flex;
    @media (max-width: 767px), (orientation: portrait) {
        height: 125vw;
    }
    p.MuiFormHelperText-root.Mui-error {
        font-size: 0.6rem;
        text-align: left;
    }
    h1 > span {
        color: ${secondary};
    }
`

const HeroImageWrapper = styled.div`
    overflow: hidden;
    position: absolute;
    width: 100%;
    height: 80vh;
    img {
        height: 100%;
        width: 100%;
    }

    @media (max-width: 767px) {
        height: 130vw;
    }

    &:before {
        background: #55411aa3;
        content: ' ';
        position: absolute;
        z-index: 1;
        height: 80vh;
        width: 100%;
    }
    @media (max-width: 767px), (orientation: portrait) {
        &:before {
            height: 100%;
        }
        img {
            height: 100%;
        }
    }
`

const Section = styled.section`
    margin: 70px auto;
    padding: 0 12px;
    max-width: 960px;
    text-align: center;
    h2 {
        font-weight: 600;
        font-size: 2.5rem;
    }
    p {
        font-size: 1.6rem;
        margin: 0 auto;
        max-width: 600px;
    }
`

const FaqSection = styled(Section)`
    h3 {
        font-size: 1.7rem;
    }
    h4 {
        font-size: 1.4rem;
    }
    h3,
    h4 {
        font-weight: 600;
        padding: 25px 0 10px 0;
    }
    h3,
    h4,
    p,
    ul,
    li {
        text-align: left;
    }
    p,
    li {
        font-size: 1.1rem;
        margin: 0;
        max-width: 100%;
    }
    ul li {
        list-style: disc;
        margin-left: 25px;
        line-height: 1.5;
    }
`

const TopGrid = styled(Grid)`
    color: white;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    h1 {
        font-weight: 700;
        font-size: 3rem;
        line-height: 1.05;
    }
    h2 {
        font-weight: 600;
        font-size: 2rem;
    }
    h1,
    h2,
    p {
        text-align: center;
    }
    p {
        font-size: 1.2rem;
    }

    @media (max-width: 767px) {
        h1 {
            font-size: 2rem;
        }
        h2 {
            font-size: 1.2rem;
        }
        > div {
            :nth-child(1) {
                display: flex;
                justify-content: center;
                flex-direction: column;
                margin-top: 15px;
            }
            :nth-child(2) {
                //margin-top: 80px;
                //background-color: white;
            }
        }
    }
`
const TopFormContainer = styled(Grid)`
    > div > div {
        min-height: 400px;
        padding: 60px 20px;
        @media (max-width: 767px) {
            padding: 20px;
        }
    }
`
const BottomFormContainer = styled.div`
    && {
        div > div > img {
            right: 100px;
            @media (max-width: 767px), (orientation: portrait) {
                right: -12px;
            }
        }
    }
`

const Overlay = styled.div``

const submitCallback = ({ query }) => {
    navigate(`https://jurigo.ca${query}`)
}

const IndexPage = ({ location, data }) => {
    return (
        <Layout location={location} noPhones={true} noFooter={true}>
            <HeroImageWrapper>
                <StyledImg
                    fluid={data.main.childImageSharp.fluid}
                    style={{ postion: 'initial' }}
                    alt={true}
                />
            </HeroImageWrapper>
            <Main>
                <TopGrid container spacing={2}>
                    <TopFormContainer
                        item
                        sm={12}
                        md={12}
                        style={{ color: 'black' }}
                    >
                        {
                            <Form
                                {...defaultFormConfig}
                                simple={false}
                                noSteps={true}
                                specificFirst={true}
                            />
                        }
                        <div>
                            {/* <MoreInfoForm
                                lawyerType="crim-transport"
                                uuid="lol"
                                withSteps={true}
                                activeStep={0}
                            /> */}
                        </div>
                    </TopFormContainer>
                </TopGrid>
            </Main>
        </Layout>
    )
}

export default IndexPage

export const query = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        main: file(relativePath: { eq: "splash.jpg" }) {
            childImageSharp {
                # Specify the image processing specifications right in the query.
                # Makes it trivial to update as your page's design changes.
                fluid(maxWidth: 1993, quality: 40) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
